export const compassEmail = ['info', ['compassbioinfo', 'com'].join('.')].join('@')
